import { Component } from '@angular/core';

import { of } from 'rxjs';

import {
  CallTemplateComponent,
  MailTemplateComponent,
  ReturnTemplateComponent,
  SnoozeTemplateComponent,
} from '@camelot/core';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [CallTemplateComponent, MailTemplateComponent, ReturnTemplateComponent, SnoozeTemplateComponent, TestIdDirective],
    template: `
    <cam-call-template
      camTestId="cam-call-template"
      [ctaService]="this.callCtaService"
      [formService]="this.callFormService"
      [items]="this.items"
    />
    <cam-mail-template camTestId="cam-mail-template" [ctaService]="this.mailCtaService" [items]="this.items" />
    <cam-return-template
      camTestId="cam-return-template"
      [ctaService]="this.returnCtaService"
      [formService]="this.returnFormService"
      [items]="this.items"
    />
    <cam-snooze-template camTestId="cam-snooze-template" [ctaService]="this.snoozeCtaService" [items]="this.items" />
  `
})
export class CoreHandlerCase {
  public callCtaService = { callBack: () => void 0 };
  public callFormService = { formatCallResult: () => ({ isSuccess: true }), getCallForm: () => [] };
  public items = [{ department: { iconPath: null, id: 1, name: 'Department one' }, id: 1, professions: ['Plumber'] }];
  public mailCtaService = { mail: () => void 0 };
  public returnCtaService = { returnBack: () => void 0 };
  public returnFormService = { formatReturnResult: () => ({ isSuccess: true }), getReturnForm: () => [] };
  public snoozeCtaService = { getSnoozeForm: () => [], snooze: () => of(null) };
}
